// extracted by mini-css-extract-plugin
export var snsList = "SnsList-module--snsList--c64f9";